import { useEffect, useState } from 'react';

/** Returns `value` only once it has stopped changing for `ms`.
 *
 *  Use this to feed anything expensive off a settled value while keeping the
 *  input itself controlled and instant: a regex recompile, a large re-filter,
 *  or a network fetch that would otherwise fire once per keystroke.
 *
 *  Do NOT remove a debounce without re-measuring the call site — each one was
 *  added against a specific measured cost, noted where it's used. */
export function useDebouncedValue<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = window.setTimeout(() => setDebounced(value), ms);
    return () => window.clearTimeout(t);
  }, [value, ms]);
  return debounced;
}
